import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../utils/constants";

// Получить все избранные товары
export const getFavorites = createAsyncThunk(
  'favorites/getFavorites',
  async (_, thunkAPI) => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        return thunkAPI.rejectWithValue('Токен не знайдено');
      }
      const res = await axios.get(`${BASE_URL}/favorites`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data?.message || err.message || 'Помилка при завантаженні обраних товарів');
    }
  }
);

// Додати товар в избранное
export const addToFavorites = createAsyncThunk(
  'favorites/addToFavorites',
  async (productId, thunkAPI) => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        return thunkAPI.rejectWithValue('Токен не знайдено');
      }
      const res = await axios.post(
        `${BASE_URL}/favorites`,
        { productId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      await thunkAPI.dispatch(getFavorites());

      return {
        productId,
        favorite: res.data.favorite,
        message: res.data.message || 'Товар додано до обраного',
      };
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data?.message || err.message || 'Помилка при додаванні до обраного');
    }
  }
);

// Видалити товар з избранного
export const removeFromFavorites = createAsyncThunk(
  'favorites/removeFromFavorites',
  async ({ favoriteId, productId }, thunkAPI) => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        return thunkAPI.rejectWithValue('Токен не знайдено');
      }

      // Используем favoriteId если есть, иначе productId
      const url = favoriteId 
        ? `${BASE_URL}/favorites/${favoriteId}`
        : `${BASE_URL}/favorites/product/${productId}`;

      await axios.delete(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      await thunkAPI.dispatch(getFavorites());

      return { favoriteId, productId };
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data?.message || err.message || 'Помилка при видаленні з обраного');
    }
  }
);

// Проверить, находится ли товар в избранном
export const checkFavorite = createAsyncThunk(
  'favorites/checkFavorite',
  async (productId, thunkAPI) => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        return { productId, isFavorite: false };
      }
      const res = await axios.get(`${BASE_URL}/favorites/check/${productId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return { productId, ...res.data };
    } catch (err) {
      return { productId, isFavorite: false };
    }
  }
);

const favoritesSlice = createSlice({
  name: "favorites",
  initialState: {
    list: [],
    isLoading: false,
    isUpdating: false,
    error: null,
    notice: null,
  },
  reducers: {
    clearFavorites: (state) => {
      state.list = [];
      state.error = null;
      state.notice = null;
    },
    clearFavoriteNotice: (state) => {
      state.notice = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFavorites.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getFavorites.fulfilled, (state, { payload }) => {
        state.list = payload;
        state.isLoading = false;
      })
      .addCase(getFavorites.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload;
      })
      .addCase(addToFavorites.pending, (state) => {
        state.isUpdating = true;
        state.error = null;
      })
      .addCase(addToFavorites.fulfilled, (state, { payload }) => {
        state.isUpdating = false;
        state.notice = payload.message;
      })
      .addCase(addToFavorites.rejected, (state, { payload }) => {
        state.isUpdating = false;
        state.error = payload;
      })
      .addCase(removeFromFavorites.pending, (state) => {
        state.isUpdating = true;
        state.error = null;
      })
      .addCase(removeFromFavorites.fulfilled, (state) => {
        state.isUpdating = false;
        state.notice = 'Товар видалено з обраного';
      })
      .addCase(removeFromFavorites.rejected, (state, { payload }) => {
        state.isUpdating = false;
        state.error = payload;
      });
  },
});

export const { clearFavorites, clearFavoriteNotice } = favoritesSlice.actions;
export default favoritesSlice.reducer;

